/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} My_Payments_Subscription_RenewsInputs */

const en_my_payments_subscription_renews = /** @type {(inputs: My_Payments_Subscription_RenewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Renews ${i?.date}`)
};

const pl_my_payments_subscription_renews = /** @type {(inputs: My_Payments_Subscription_RenewsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Odnawia się ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Renews {date}" |
*
* @param {My_Payments_Subscription_RenewsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const my_payments_subscription_renews = /** @type {((inputs: My_Payments_Subscription_RenewsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Payments_Subscription_RenewsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_my_payments_subscription_renews(inputs)
	return en_my_payments_subscription_renews(inputs)
});